import type { Components, Theme } from '@mui/material/styles';

export const tableContainerTheme: Components<Theme>['MuiTableContainer'] = {
  styleOverrides: {
    root: {
      '& tbody > tr:last-of-type > td': {
        borderBottom: 'none'
      }
    }
  }
};

export const tableTheme: Components<Theme>['MuiTable'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.vars.palette.semantic.divider.primary}`,
      borderRadius: '8px'
    })
  }
};

export const tableHeadTheme: Components<Theme>['MuiTableHead'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: `linear-gradient(0deg, rgba(0, 102, 138, 0.05), rgba(0, 102, 138, 0.05)), ${theme.vars.palette.semantic.background.base}`,
      '& .MuiTableCell-root': {
        borderBottom: `1px solid ${theme.vars.palette.semantic.border.tertiary}`
      }
    })
  }
};
